import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DropdownButton, MenuItem, IconButton } from 'modules/ui';
import { Colors } from 'modules/theme';
import styles from './TopCandidatesActionButtons.module.scss';

export default function TopCandidatesActionButtons({
  onAddByNameClick,
  onShareClick,
  projectFinished,
}) {
  const navigate = useNavigate();

  function handleAddFromSearchClick() {
    navigate('/search');
  }

  return (
    /* This div here is important so that flex doesn't apply on buttons */
    <div>
      <IconButton
        label="Share list"
        iconName="shareTopCandidates"
        iconSize={20}
        iconClassName={styles.shareIcon}
        className={styles['actionButton--secondary']}
        onClick={onShareClick}
        size="large"
      />
      <DropdownButton
        primary
        disabled={projectFinished}
        buttonClassName={styles.actionButton}
        label="Add talent"
        iconName="downArrow"
        iconSize={10}
        iconColor={Colors.white}
        iconStyle={{ left: 30 }}
        arrowRightPosition="10px"
      >
        <MenuItem
          text="Add from search"
          icon="plus"
          onClick={handleAddFromSearchClick}
        />
        <MenuItem text="Add by name" icon="plus" onClick={onAddByNameClick} />
      </DropdownButton>
    </div>
  );
}
